import { observer } from 'mobx-react'
import React from 'react'
import { View, StyleSheet } from 'react-native'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'

interface PropTypes {
  style?: any
  progress: number[]
  baseValue: number
  colors?: string[]
}

const defaultColors = ['#00A0F3', '#DB2424', '#FF7926']

export const MultiColorProgressBar = observer(
  ({ baseValue, progress, style, colors: propColors }: PropTypes) => {
    const colors = propColors || defaultColors

    return (
      <View style={composeStyle(styles.root, style)}>
        {progress.map((value, i) => {
          const proportion = Math.round((100 * value) / baseValue)
          return (
            <View
              key={i}
              style={[
                {
                  height: 8,
                  flex: proportion,
                  backgroundColor: colors[i],
                },
                styles.progress,
              ]}
            />
          )
        })}
      </View>
    )
  },
)

const styles = StyleSheet.create({
  root: {
    height: 8,
    borderRadius: 9,
    marginTop: 10,
    backgroundColor: 'rgba(0, 160, 243, 0.06)',
    flexDirection: 'row',
  },
  progress: {
    borderRadius: 9,
  },
})
